import React, { useState } from "react";
import "./TimePicker.css";

let d = new Date();

let hour = d.getHours();
let minute = d.getMinutes();

const TimePicker = ({ timeValue, onHandleTimeChange, onClickClose }) => {
  const [time, setTime] = useState();
  const [hourUpdate, setHourUpdate] = useState(timeValue.split(":")[0]);
  const [minUpdate, setMinUpdate] = useState(timeValue.split(":")[1]);

  hour = parseInt(timeValue.split(":")[0]);
  minute = parseInt(timeValue.split(":")[1]);

  const hrUpHandler = () => {
    hour++;
    if (hour > 23) {
      hour = 0;
    }
    let newTime = formatTime(hour) + ":" + formatTime(minute);
    setHourUpdate(formatTime(hour));
    setTime(newTime);
    onHandleTimeChange(newTime);
  };

  const hrDownHandler = () => {
    hour--;
    if (hour < 0) {
      hour = 23;
    }
    let newTime = formatTime(hour) + ":" + formatTime(minute);
    setHourUpdate(formatTime(hour));
    setTime(newTime);
    onHandleTimeChange(newTime);
  };

  const minUpHandler = () => {
    minute++;
    if (minute > 59) {
      minute = 0;
      hour++;
    }
    let newTime = formatTime(hour) + ":" + formatTime(minute);
    setHourUpdate(formatTime(hour));
    setMinUpdate(formatTime(minute));
    setTime(newTime);
    onHandleTimeChange(newTime);
  };

  const minDownHandler = () => {
    minute--;
    if (minute < 0) {
      minute = 59;
      hour--;
    }
    let newTime = formatTime(hour) + ":" + formatTime(minute);
    setHourUpdate(formatTime(hour));
    setMinUpdate(formatTime(minute));
    setTime(newTime);
    onHandleTimeChange(newTime);
  };

  const formatTime = (time) => {
    // if (time < 10) {
    //   time = "0" + time;
    // }
    return time;
  };
  return (
    <div className="">
      <div className="time-picker" data-time="00:00">
        <div className="hour">
          <div onClick={hrUpHandler} className="hr-up"></div>

          <div className="hr">{hourUpdate}</div>

          <div
            onClick={hrDownHandler}
            onScroll={() => {}}
            className="hr-down"
          ></div>
        </div>

        <div className="font-medium text-3xl h-5 top-8 absolute">:</div>

        <div className="minute">
          <div onClick={minUpHandler} className="min-up"></div>
          <div className="min animate__animated animate__fadeInUp">
            {minUpdate}
          </div>
          <div onClick={minDownHandler} className="min-down"></div>
        </div>
      </div>
      <div className="-translate-y-8 bg-secondary rounded-br-md rounded-bl-md py-1.5 my-3 ">
        <div className="flex justify-between mx-2 ">
          <div
            onClick={onClickClose}
            className="text-sm text-white cursor-pointer"
          >
            Close
          </div>
          <div
            onClick={onClickClose}
            className="text-sm text-white cursor-pointer"
          >
            Set
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimePicker;
